module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area03_img_cn@2x.73378569.png";